<template>
  <div class="page-content">
    <div
      class="page-content__header-description"
      style="display: flex;padding: 10px 0 !important; flex-flow: column; margin-bottom:30px"
    >
      <el-breadcrumb separator="/" class="col-sm-6">
        <el-breadcrumb-item :to="{ path: '/' }">Dashboard</el-breadcrumb-item>
        <can I="read" a="all">
          <el-breadcrumb-item :to="{ path: '/devices/all_devices' }">Installation Management</el-breadcrumb-item>
        </can>
        <el-breadcrumb-item>Commission Installation</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="col-md-12">
      <form id="inventoryCommission" @submit.prevent="submitRequest">
        <div class="row">
          <div class="col-md-4">
            <!-- customer information block -->
            <el-card style="margin-bottom: 10px">
              <div class="page-content__header-description">Customer</div>

              <div class="row list-group">
                <div class="list-group-item">
                  <dt class>CID</dt>
                  <dd
                    class
                  >{{ `${InstallationData.deviceRequest && InstallationData.deviceRequest.CID ? InstallationData.deviceRequest.CID : 'nill'}`}}</dd>
                </div>
                <div class="list-group-item">
                  <dt class>Full Name</dt>
                  <dd
                    class
                  >{{ `${InstallationData.deviceRequest.user.firstName} ${InstallationData.deviceRequest.user.lastName}`}}</dd>
                </div>
                <div class="list-group-item">
                  <dt class>Email Address</dt>
                  <dd class>{{ `${InstallationData.deviceRequest.user.email} ` }}</dd>
                </div>
                <div class="list-group-item">
                  <dt class>Product Name</dt>
                  <dd class>{{ ` ${InstallationData.deviceRequest.deviceType.name}` }}</dd>
                </div>
                <div class="list-group-item">
                  <dt class>Payment Model</dt>
                  <dd class>{{ ` ${InstallationData.deviceRequest.paymentModel}` }}</dd>
                </div>
              </div>
            </el-card>

            <el-card style="margin-bottom: 10px">
              <!-- schedule installation block -->
              <div class="page-content__header-description">Installation Info</div>
              <hr />
              <div class>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label style="text-transform: capitalize;" for="location">Address</label>
                      <address-input
                        v-model="formData.address"
                        :changeHandler="getAddressData"
                        placeholder="Type Address"
                      ></address-input>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label
                        style="text-transform: capitalize;"
                        for="expiryDate"
                      >Warranty Expiry Date</label>
                      <el-date-picker
                        type="date"
                        placeholder="Pick an Expiry date"
                        v-model="formData.warranty"
                        style="width: 100%;"
                      ></el-date-picker>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label
                        style="text-transform: capitalize;"
                        for="maintenanceType"
                      >Maintenance Type</label>
                      <el-select
                        v-model="formData.maintenance"
                        placeholder="Pick a Maintenance Type"
                        style="width: 100%;"
                      >
                        <el-option
                          v-for="item in maintenanceOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
            </el-card>
          </div>

          <div class="col-md-8">
            <el-card style="margin-bottom: 10px">
              <div class="page-content__header-description">Assign Operation Engineer</div>
              <hr />
              <el-form-item class="form-item" label="Assigned To">
                <el-autocomplete
                  style="width: 100%"
                  id="customer-contact"
                  class="inline-input"
                  v-model="assignedTo"
                  :fetch-suggestions="userSearch"
                  placeholder="Search User"
                  prefix-icon="el-icon-search"
                  @select="userSelected"
                ></el-autocomplete>
              </el-form-item>
            </el-card>
          </div>
          <!-- {{JSON.stringify(InstallationData.deviceRequest.installationComponents)}} -->
          <div class="col-md-8">
            <el-card>
              <div class="page-content__header-description">Components</div>
              <hr />
              <div role="tablist" class="col-md-12">
                <div
                  v-for="(compSelect, index) in InstallationData.deviceRequest.installationComponents"
                  :key="index"
                >
                  <b-card no-body class="mb-1 statistic-widget statistic-widget-f">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <a
                        class="order-collapse__header"
                        href="#"
                        v-b-toggle="'accordion_comp'+index"
                      >
                        <h5 style="text-transform: capitalize;">{{compSelect.componentItems.name}}</h5>
                        <b-badge variant="info" style="font-size: 1.5rem; color: #fff;">
                          Quantity: {{ compSelect.quantity }}
                          <b-badge
                            class="inset"
                            v-if="filterList(availableComponentsList,compSelect).length<=compSelect.quantity"
                          >less than {{compSelect.quantity}} item in stock</b-badge>
                        </b-badge>
                      </a>
                    </b-card-header>
                    <b-collapse
                      :id="'accordion_comp'+index"
                      collapse
                      show
                      order-collapse-inner
                      visible
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <div
                          v-if="data = isSolarPanels(compSelect.componentItems.name, availableComponentsList)"
                        >
                          <div v-html="showSolarInputs(data, compSelect.quantity)"></div>
                        </div>
                        <div v-else>
                          <b-form-select
                            v-for="i in compSelect.quantity"
                            v-bind:name="compSelect.componentTypeId+'__'+i"
                            v-model="rows['__'+compSelect.componentItems.name+'__'+i]"
                            :key="compSelect.componentTypeId+'__'+i"
                            :options="filterList(availableComponentsList,compSelect)"
                            class="mb-3 componentType"
                            style="text-transform: capitalize !important"
                          ></b-form-select>
                        </div>
                        <!-- {{compSelect}} -->
                        <!-- <span>{{ errors.first(compSelect.componentTypeId+'__'+i) }}</span> -->
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </div>
              <div class="col-md-12" style="margin: 30px; text-align: center;">
                <button class="btn btn-secondary btn-lg" type="submit">Commission Installation</button>
              </div>
            </el-card>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
//import Autocomplete from "../../utils/Autocomplete";
import Vue from "vue";
import AddressInput from "@/components/utils/GoogleAddressSuggest.vue";
import { mapGetters, mapActions } from "vuex";
import HotelDatePicker from "vue-hotel-datepicker";
import {
  Select,
  DatePicker,
  Card,
  Form,
  Autocomplete,
  Breadcrumb,
  BreadcrumbItem
} from "element-ui";
// import { Datetime } from "vue-datetime";
// import "vue-datetime/dist/vue-datetime.css";
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);

export default {
  name: "instalationCommission",
  components: {
    Autocomplete,
    AddressInput,
    HotelDatePicker,
    "el-autocomplete": Autocomplete,
    "el-date-picker": DatePicker,
    "el-form-item": Form,
    "el-card": Card
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
      assignedTo: null,
      addressParam: {},
      maintenanceOptions: [
        {
          value: 60,
          label: "Bi-Monthly (Two Months)"
        },
        {
          value: 90,
          label: "Quarter (Three Months)"
        }
      ],
      assignList: [],
      maintenanceValue: "",
      Address: "",
      expiryDate: "",
      requestId: this.$route.params.Installation,
      InstallationData: {
        deviceRequest: {
          user: {},
          deviceType: {}
        }
      },
      formData: {
        warranty: null,
        maintenance: null,
        address: null,
        assignedTo: null
      },
      componentsToUse_public: {},
      availableComponentsList: [],
      rows: {},
      results: {},
      inventories: null,
      periods: {
        from: null,
        to: null
      },
      tempData: ""
    };
  },
  computed: {
    ...mapGetters([
      "getUserById",
      "getDeviceById",
      "getUsers",
      "getDummy",
      "getDevices",
      "getUserSession"
    ]),
    componentsToUse: {
      // getter
      get: function() {
        return this.componentsToUse_public;
      },
      // setter
      set: function(newValue) {
        this.componentsToUse_public = newValue;
      }
    }
  },
  methods: {
    userSearch(queryString, cb) {
      let users = this.assignList;
      var results = queryString
        ? users.filter(user => this.createFilter(queryString, user))
        : users;
      cb(results);
    },
    fetchAssignList() {
      const HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      const url = `/users?filter[include][installations]=deviceType&filter[where][roleType]=customer operations engineer`+`&filter[order]=id DESC`;
      HTTP.get(url)
        // .then(response => {
        //   const usersList = response.data;
        //   console.log(usersList)
        //   this.$store.commit("saveUsers", usersList);
        //   // console.log(this.getUserById(1))
        // })
        .then(response => response.data)
        .then(tempList => {
          // console.log(tempList);

          this.assignList = tempList.map(x => ({
            ...x,
            value: `${x.firstName} ${x.lastName}`
          }));
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    showSolarValues(value, index) {
      // console.log(value, index)
      if (value[index]) {
        console.log("you", value.value);
        return value[index].value;
      }
      return "---";
    },
    showSolarInputs(values, quantity) {
      let output = "";

      for (let i = 0; i < quantity; i++) {
        const itemValue = (values[i] && values[i].value) || "---";
        output += `
          <input
            type="text"
            value="${itemValue}"
            disabled="true"
            class="componentType form-control"
            style="text-transform: capitalize !important; margin-bottom: 10px"
          />
        `;
      }

      return output;
    },
    userSelected(user) {
      this.formData = {
        ...this.formData,
        assignedTo: user["id"]
      };
      //  console.log({
      //   form: this.form
      // });
    },
    setCheckin(chkInDate) {
      this.periods.from = chkInDate;
      console.log(this.periods.from);
    },
    setCheckOut(chkOutnDate) {
      this.periods.to = chkOutnDate;
      // console.log(this.periods.to);
    },
    filterList(arrayVal, component) {
      const dat = arrayVal.filter(x => {
        return x.componentId === component.componentTypeId;
      });
      dat.unshift({
        value: null,
        disabled: true,
        text: "Please Select " + component.componentItems.name
      });
      return dat;
    },
    validateRequestForm(entries) {
      console.log("}}}}}}}}}}}}}}}}}}}}}}}}");

      console.log(entries);

      let qty = 0;
      this.InstallationData.deviceRequest.installationComponents.forEach(a => {
        if (a.componentTypeId === 1 || a.componentTypeId === 2) {
          qty += a.quantity;
        }
      });
      let _formData = this.formData;
      // if (
      //   !_formData.warranty ||
      //   !_formData.maintenance ||
      //   !this.formData.address
      // ) {
      //   return "Please installation details!";
      // }

      // for (let [field, value] of Object.entries(this.periods)) {
      //   if (value === null || value === "") {
      //     return "Please fill all fields!";
      //   }
      // }
      // console.log(qty, Object.keys(entries).length);
      return qty > Object.keys(entries).length
        ? "Please fill all entries !!!"
        : false;
    },
    duplicateEntries(param) {
      const names = Object.values(param);
      const count = names =>
        names.reduce((a, b) => Object.assign(a, { [b]: (a[b] || 0) + 1 }), {});
      const duplicates = dict => Object.keys(dict).filter(a => dict[a] > 1);
      let c = count(names);
      let d = duplicates(count(names));
      return d.length > 0 ? d : false;
    },
    compareDate(date1, date2) {
      let now = new Date();
      let myDate = new Date(date1);
      let myDate2 = new Date(date2);

      // console.log({
      //   now,
      //   myDate,
      //   date2
      // });
      return now > myDate
        ? "Past Date"
        : myDate > myDate2
        ? "Invalid Date supplied"
        : false;
    },
    /**
     * When the location found
     * @param {Object} addressData Data of the found location
     * @param {Object} placeResultData PlaceResult object
     * @param {String} id Input container ID
     */
    getAddressData(addressData, placeResultData, id) {
      this.addressParam = {
        position: {
          lat: addressData.latitude,
          lng: addressData.longitude
        },
        streetNumber: addressData.street_number,
        streetRoute: `${addressData.route ? addressData.route : ""} - ${
          addressData.locality ? addressData.locality : ""
        }, ${addressData.country ? addressData.country : ""}`,
        stateId: 0,
        countryId: 0,
        locationId: 0,
        lgaId: 0,
        userId: this.InstallationData.userId,
        installationId: this.InstallationData.id,
        deviceRequestId: this.InstallationData.deviceRequestId
      };
      // console.log(this.addressParam);
    },
    submitAddressUpdate() {
      const container = this;
      const HTTP = this.$httpUtils.instance;
      const url = "/locations";
      HTTP.post(url, this.addressParam)
        .then(response => {
          container.dialogVisible = false;
          this.showSuccessMsg({
            message: "Installation successfully commissioned!"
          });
          setTimeout(() => {
            container.$router.push({
              path: `/device/${container.addressParam.installationId}`
            });
          }, 500);
        })
        .catch(error => {
          var errorMsg = error.response.data.error.details.messages;
          var errTemp = [];
          var keyHooks = Object.keys(errorMsg);
          Object.values(errorMsg).map((x, index) => {
            errTemp[index] = keyHooks[index] + " " + x[0];
          });
          errTemp = Object.values(errTemp).join("<br>");
          this.showErrorMsg({
            message: errTemp
          });
        });
    },
    submitRequest(event) {
      event.preventDefault();

      const HTTP = this.$httpUtils.instance;
      const container = this;
      let inverters = "";
      let chk = this.duplicateEntries(this.rows);
      console.log(this.rows);

      console.log(chk);

      if (chk !== false) {
        this.showErrorMsg({
          message: "Duplicate entries for " + chk.toString()
        });
        return;
      }
      // this.rows.__inverter__5 = 8585858;
      // this.rows.__inverter__6 = 8585855;
      for (var key in this.rows) {
        if (key.toLowerCase().indexOf("inverter") > -1) {
          inverters += `${this.rows[key]} `;
        }
      }

      console.log(this.rows);
      console.log(this.formData);
      console.log("---=========------");

      let scope = {
        solarKitIds: inverters.trim(),
        status: "commissioned",
        commissioned: new Date().toLocaleDateString(),
        ...this.formData
      };
      chk = this.validateRequestForm(this.rows);
      if (chk !== false) {
        this.showErrorMsg({
          message: chk
        });
        return;
      }
      // console.log({ scope });
      HTTP.patch(`/installations/${this.InstallationData.id}`, scope)
        .then(response => {
          const Response = response.data;
          if (Response) {
            let kitId = Response.id;
            scope = [];
            let a = [];
            for (var key in this.rows) {
              scope.push({
                serialNumber: this.rows[key],
                installationId: kitId
              });
              a.push(this.rows[key]);
            }
            HTTP.post(`/installation_trackers`, scope).then(data => {
              HTTP.patch(
                `/device_requests/${this.InstallationData.deviceRequest.id}`,
                {
                  status: 4
                }
              ).then(data => {
                HTTP.post(
                  `/inventories/update?where={"serialNumber":{"inq":[${a}]}}`,
                  {
                    status: "1"
                  }
                ).then(data => {
                  container.submitAddressUpdate();
                });
              });
            });
          }
        })
        .catch(error => {
          console.log(error);

          this.showErrorMsg({
            message: "error occured"
          });
        });
    },
    availableComponents(typeIds) {
      const HTTP = this.$httpUtils.instance;
      const context = this;
      const url = `/inventories/?filter={"limit": "1000",  "order": "serialNumber ASC", "where": {"status": "0", "componentId": { "inq": ${typeIds}}}}`;
      HTTP.get(url)
        .then(response => {
          const componentList = response.data;
          // console.log(componentList);
          componentList.filter(x => {
            x.value = x.serialNumber;
            x.text = x.serialNumber;
          });
          context.availableComponentsList = componentList;
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    formatTime(date) {
      var date = new Date(date); //or your date here
      return `${date.getHours()} : ${date.getMinutes()} :  ${date.getSeconds()}`;
    },
    formatDate(date) {
      var date = new Date(date); //or your date here
      return `${date.getFullYear()} / ${date.getMonth() +
        1}  /  ${date.getDate()}`;
    },
    componentName(id) {
      // console.log(this.componentsToUse);
      // this.tempData = this.componentsToUse.find(x => x.id == id)[
      //   "component"
      // ]["name"];
      // return this.tempData;
    },
    isSolarPanels(name, arrayVal) {
      if (name == "solar panels") {
        // this too is hardcodded...
        const dat = arrayVal.filter(x => {
          return x.componentId === 3; //this is hardcodded...
        });
        return dat;
      }
      return false;
    },
    componentTypeNames() {
      const HTTP = this.$httpUtils.instance;
      const container = this;
      HTTP.get(
        `/component_types/?filter={"include": {"relation": "component","scope": {"where": {"id": "componentId" }}}}`,
        {}
      ).then(rolesdata => {
        container.componentsToUse = rolesdata.data;
        // console.log(container.componentsToUse);
      });
    },
    getInstallationData() {
      const HTTP = this.$httpUtils.instance;
      let filter = {
        order: "id DESC",
        where: { status: "scheduled" },
        include: {
          deviceRequest: [
            "user",
            "deviceType",
            { installationComponents: ["componentItems"] }
          ]
        }
      };

      // HTTP.get(
      //   `/device_requests/${this.requestId}?filter={"include": ["user","deviceType",{"installationComponents":["componentItems"]}]}`
      // )
      // console.log(JSON.stringify(filter));
      HTTP.get(
        // `/device_requests/?filter={"include": ["user","deviceType","installationComponents"], "where": {"status": 3}, "order": "id DESC" }`,
        `/installations/${this.requestId}?filter=${JSON.stringify(filter)}`,
        {}
      ).then(resp => {
        // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>");
        // console.log(resp.data.deviceRequest.installationComponents);
        let requiredComponents = resp.data.deviceRequest.installationComponents.map(
          x => x.componentItems.id
        );
        this.availableComponents(JSON.stringify(requiredComponents));
        this.InstallationData = resp.data;
      });
    }
  },
  mounted() {
    // this.componentTypeNames();
    this.getInstallationData();
    this.assignList = this.fetchAssignList();
  }
};
</script>

<style>
a.cell {
  color: #606266 !important;
  margin: 0 auto;
}
label {
  padding: 0px;
}
</style>

<style lang="scss" scoped>
a:not([href]):not([tabindex]) {
  color: #606266 !important;
  cursor: pointer;
}

.section-container {
  border-radius: 7px;
  background: #fff;
  -webkit-box-shadow: 0 4px 70px -18px rgba(0, 0, 0, 0.2);
  box-shadow: 0 4px 70px -18px rgba(0, 0, 0, 0.2);
  margin-bottom: 1.875rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  min-height: 200px;
}

.form-group {
  width: 100%;
}

.custom-control-description {
  margin-left: 12px;
}

#__BVID__36___BV_label_,
#__BVID__40___BV_label_ {
  font-size: 13px !important;
}

.card-header {
  padding: 0;
}

.statistic-widget-f {
  border-bottom: 1px solid #f4f4f4;
  /* padding: 1rem 1.9rem; */
}

.test-basic__format span {
  font-weight: 800;
  color: #269af1;
}
.badge.inset {
  font-size: 8px;
  text-transform: lowercase;
  background: inherit;
  color: white;
  padding: 0;
  margin-left: 2px;
}

.badge.inset:before {
  content: "( ";
}

.badge.inset:after {
  content: " )";
}

.badge-info {
  background-color: #f6bb42;
  text-transform: lowercase;
  font-size: 8px !important;
  border-radius: 30px;
}

.badge {
  min-width: auto;
}

.order-collapse__header h5 {
  font-weight: bold;
  color: #111111;
}

.card-body {
  margin-bottom: 20px;
}

.order-collapse__header {
  padding: 1rem 0 1rem 0;
}

.componentType {
  margin: 1rem 0 1rem 0;
}

.list-group-item {
  padding: 1.5rem 2rem;
}

dd {
  color: #999999;
}

/* .dateInput {
  margin-left: 12px;
  border: 1px solid rgba(211, 217, 221, 0.6);
} */

/** datepicker styles **/
/* .datepicker__dummy-wrapper--is-active{
  border: 1px solid #1a93ca !important;
}

.datepicker__month-day--selected{
  background-color: rgba(26, 147, 202, 0.66);
} */

.datepicker__input:focus {
  outline: none;
  color: #00ca9d !important;
}
</style>





// WEBPACK FOOTER //
// src/components/pages/instalation/installationCommission.vue